import ModalGrupoDesconto from "./ModalGrupoDesconto";

interface EditGrupoDescontoProps {
  grupoDescontoEditId?: string;
  isOpenModal: boolean;
  onClose: () => any;
  onSuccess?: () => any;
}

function EditGrupoDesconto({
  grupoDescontoEditId,
  isOpenModal,
  onSuccess,
  onClose,
}: EditGrupoDescontoProps) {
  return (
    <>
      {isOpenModal ? (
        <ModalGrupoDesconto
          isOpen={isOpenModal}
          id={grupoDescontoEditId}
          onClose={onClose}
          onSaved={onSuccess}
        />
      ) : null}
    </>
  );
}

export default EditGrupoDesconto;
